import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
let ls = new SecureLS({ encodingType: 'des', isCompression: false, encryptionSecret: 'onenor' });
let version = '1.0.1'
Vue.use(Vuex)
let x = ls.get('vuex')
if (!localStorage.getItem('vuex') || (typeof x === 'string' ? JSON.parse(x) : x).version !== version) {
  ls.set('vuex', {})
}

export default new Vuex.Store({
  state() {
    return {
      version,
      user: { current_org: {} },
      routerViews: {},
      logged: 'n',
      search: '',
      global_token: '',
      lastTime: Date.now(),
      timeDelta: 0,
      userGroups: [],
      initparam: {
        title: '[会议室预约]', urlData: { req: 'get_meeting_room_appointments_by_id', id: 0 }, confirm: '提交', cmd: 'add', name: '',
        inputs: {//[{ v: 4, l: '校级会议' }, { v: 3, l: '院级会议' }, { v: 2, l: '系级会议' }, { v: 1, l: '学术报告' }, { v: 0, l: '组会' }, { v: 5, l: '其他' },]
          test_type: { type: 'radio', label: '会议类型', value: '院级会议', valueList: [{ v: '校级会议', l: '校级会议' }, { v: '院级会议', l: '院级会议' }, { v: '系级会议', l: '系级会议' }, { v: '学术报告', l: '学术报告' }, { v: '组会', l: '组会' }, { v: '其他', l: '其他' },] },
          name: { type: 'text', label: '会议主题', validate: '^\\S{2,}$', requirement: '会议主题需大于等于两个文字。' },
          recurring: { type: 'radioGroup', label: '预约方式', value: 0, valueList: [{ l: '单次', v: 0, desc: '单次预约' }, { l: '每周', v: 2, desc: '每周循环' }], showDomain: [2], controls: ['recur_param_list'], buttons: [{ id: 'thisWeek', label: '预约本周', abbr: '本周', desc: '预约本周' }] },
          recur_param_list: { type: 'checkbox', label: '工作日', value: [], valueList: [{ v: '0', l: '周日' }, { v: '1', l: '周一' }, { v: '2', l: '周二' }, { v: '3', l: '周三' }, { v: '4', l: '周四' }, { v: '5', l: '周五' }, { v: '6', l: '周六' },], hide: true },
          sDate: { type: 'date', label: '开始日期', value: '' },
          sTime: { type: 'time', label: '开始时间', value: '' },
          eDate: { type: 'date', label: '结束日期', value: '' },
          eTime: { type: 'time', label: '结束时间', value: '' },
          sample_number: { type: 'number', label: '人数', validate: '^[1-9]\\d*$', requirement: '人数必须为正整数。' },
          participant: { type: 'transfer', label: '参会人员', value: [], valueList: [] },//valueList:[{key:'1',l:'1',...}],valueListReq:'getGroupMembers'
          remark: { type: 'text', label: '备注', value: '' },
        },
      },
    }
  },
  mutations: {
    setUser: (state, u) => {
      state.user = u
    },
    setUserProperty: (state, u) => {
      state.user = Object.assign(state.user, u)
    },
    popHistory: (state) => {
      return state.history.pop();
    },
    setRouterViews: (state, r) => {
      state.routerViews[r.name || r.path] = r.params
    },
    setGlobalToken: (state, t) => {
      state.global_token = t
    },
    setLogged: (state, l) => {
      state.logged = l
    },
    updateState: () => {
      localStorage.setItem('expireStamp', Date.now())
    },
    setSearch: (state, s) => {
      state.search = s
    },
    setInitparam: (state, i) => {
      state.initparam = i
    },
    setInitparamProperty: (state, i) => {
      state.initparam = Object.assign(state.initparam, i)
    },
    setLastTime: (state, t) => {
      state.lastTime = t * 1000
      state.timeDelta = Date.now() - state.lastTime
    },
    setUserGroups: (state, u) => {
      state.userGroups = u
    }
  },
  methods: {
  },
  getters: {

  },
  actions: {

  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
})
